module.exports = __webpack_public_path__ + "img/logo-transparente.53e8b146.png";